export const propertyAssetTypesList = [
  { name: "Condo", value: "28adf0b5-4719-11e9-a208-0242ac140002" },
  { name: "Data Center", value: "28adf1ee-4719-11e9-a208-0242ac140002" },
  { name: "Flex", value: "28adeee9-4719-11e9-a208-0242ac140002" },
  { name: "Hotel", value: "28adf151-4719-11e9-a208-0242ac140002" },
  { name: "Industrial", value: "28adf5c0-4719-11e9-a208-0242ac140002" },
  { name: "Land", value: "28adef82-4719-11e9-a208-0242ac140002" },
  { name: "Medical", value: "28adf32e-4719-11e9-a208-0242ac140002" },
  { name: "Mixed-Use", value: "28adee52-4719-11e9-a208-0242ac140002" },
  { name: "Multifamily", value: "28adf474-4719-11e9-a208-0242ac140002" },
  { name: "Office", value: "28adf667-4719-11e9-a208-0242ac140002" },
  { name: "Other", value: "28adedbc-4719-11e9-a208-0242ac140002" },
  { name: "Residential", value: "28adf01b-4719-11e9-a208-0242ac140002" },
  { name: "Retail", value: "28adf519-4719-11e9-a208-0242ac140002" },
  { name: "Senior Living", value: "28adf28d-4719-11e9-a208-0242ac140002" },
  { name: "Student Housing", value: "28adf3d0-4719-11e9-a208-0242ac140002" }
];

export default {
  CONDO: "28adf0b5-4719-11e9-a208-0242ac140002",
  DATA_CENTER: "28adf1ee-4719-11e9-a208-0242ac140002",
  FLEX: "28adeee9-4719-11e9-a208-0242ac140002",
  HOTEL: "28adf151-4719-11e9-a208-0242ac140002",
  INDUSTRIAL: "28adf5c0-4719-11e9-a208-0242ac140002",
  LAND: "28adef82-4719-11e9-a208-0242ac140002",
  MEDICAL: "28adf32e-4719-11e9-a208-0242ac140002",
  MIXED_USE: "28adee52-4719-11e9-a208-0242ac140002",
  MULTIFAMILY: "28adf474-4719-11e9-a208-0242ac140002",
  OFFICE: "28adf667-4719-11e9-a208-0242ac140002",
  OTHER: "28adedbc-4719-11e9-a208-0242ac140002",
  RESIDENTIAL: "28adf01b-4719-11e9-a208-0242ac140002",
  RETAIL: "28adf519-4719-11e9-a208-0242ac140002",
  SENIOR_LIVING: "28adf28d-4719-11e9-a208-0242ac140002",
  STUDENT_HOUSING: "28adf3d0-4719-11e9-a208-0242ac140002"
};
